import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  CalendarDays,
  CalendarRange,
  Calendar,
  ClipboardList,
  Clock,
  LayoutDashboard,
  Users,
  Inbox,
  BookOpen,
  RefreshCw,
  LogOut,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { clearAdminPassword } from "@/lib/auth/storage";

const links = [
  { href: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { href: "/admin/register", label: "Daily Register", icon: ClipboardList },
  { href: "/admin/weekly", label: "Weekly", icon: Calendar },
  { href: "/admin/monthly", label: "Monthly", icon: CalendarRange },
  { href: "/admin/shifts", label: "Employee Shifts", icon: Clock },
  { href: "/admin/holidays", label: "Holidays", icon: CalendarDays },
  { href: "/admin/people", label: "People", icon: Users },
  { href: "/admin/notices", label: "Notices", icon: Inbox },
  { href: "/admin/mantras", label: "Mantras", icon: BookOpen },
  { href: "/admin/sync", label: "Sync Devices", icon: RefreshCw },
];

export function AdminNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <header className="border-b bg-white">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-saffron-700">
            BCEC Attendance
          </p>
          <h1 className="text-lg font-semibold text-foreground">Coordinator</h1>
        </div>
        <nav className="flex flex-wrap gap-1">
          {links.map(({ href, label, icon: Icon, exact }) => {
            const active = exact
              ? pathname === href
              : pathname.startsWith(href);
            return (
              <Link
                key={href}
                to={href}
                className={cn(
                  "inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  active
                    ? "bg-saffron-50 text-saffron-800"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                )}
              >
                <Icon className="h-4 w-4" />
                <span className="hidden sm:inline">{label}</span>
              </Link>
            );
          })}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              clearAdminPassword();
              navigate("/admin/login");
            }}
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </nav>
      </div>
    </header>
  );
}
